import { contract } from './contract';

export const num = contract<number>('number');
